{
    "coordinates": [
        45.68521959138306,
        -64.45202801148571
    ],
    "tooltip": "Joggins",
    "title": "Joggins Formation",
    "country": "Canada",
    "period": "Carboniferous",
    "alt": "TODO"
}
